import * as React from "react";
import { Table, Col, Row, Grid } from "react-bootstrap";
import { EstructuraEmpresa, EstructuraSede, EstructuraSuraEmpresa } from "../modelo/EstructuraEmpresa";
import ContenidoPestañaEmpresa from "./ContenidoPestañaEmpresa";
import icoSedes from "../../../../../../assets/img/ico-sedes.png";

export default class TablaSedesEmpresa extends React.Component<TablaSedesEmpresaProps, TablaSedesEmpresaState> {
    
    constructor(props: any) {
        super(props);

        this.state = {
            listaSedes: [],
            totalSedes: 0,
            listaPaginada: [],
            paginaActual: 0,
            registrosPorPagina: 20 
        };
    }

    componentDidMount() {
        if(this.state.listaSedes.length === 0 || this.state.listaPaginada.length === 0) {
            this.obtenerListaSedes();
        }
    }

    render() {
        return(
            <div>
                <ContenidoPestañaEmpresa
                    estructuraEmpresa={this.props.estructuraEmpresa}
                    estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                    tituloCabecera={"Datos Sedes Sistema de Afiliación Transaccional"}
                    contenido={this.renderContenido()}
                />
            </div>
        );
    }

    renderContenido() {
        const {listaPaginada} = this.state;

        return(
            <Table striped responsive bordered condensed hover>
                <tbody>
                    {
                        listaPaginada.map((sede, index) => (
                        <tr key={index}>
                            <td>
                                <Grid style={{width: '1050px'}}>
                                    <Row className="show-grid" style={{marginTop: '15px', marginBottom: '10px'}}>
                                        <Col sm={1}>
                                            <img src={icoSedes} style={{position: 'absolute', top: 5, left: 18, height: 70, width: 70}}/>
                                        </Col>
                                        <Col sm={4} md={4}>
                                            <div style={{fontSize: '14px'}}>
                                                <Row><b className="title-col">SEDE #{sede.informacionSede.codigoSede} - {sede.informacionSede.nombreSede}</b></Row>
                                                <Row>{sede.informacionSede.direccionSede}</Row>
                                                <Row><b>Correo:</b> {sede.informacionSede.correoSede}</Row>
                                                <Row><b>Teléfono:</b> {sede.informacionSede.telefonoSede}</Row>
                                            </div>
                                        </Col>
                                        <Col sm={4} md={3}>
                                            <div style={{fontSize: '14px'}}>
                                                <Row><b>Sede Principal:</b> {sede.informacionSede.sedePrincipal}</Row>
                                                <Row><b>Municipio:</b> {sede.informacionSede.municipioSede}</Row>
                                                <Row>
                                                    <b>Zona Ubicación:</b> 
                                                    {` ${(sede.informacionSede.zonaUbicacionSede === 'R' ? 'RURAL' : 
                                                         (sede.informacionSede.zonaUbicacionSede === 'U' ? 'URBANA' : 
                                                         sede.informacionSede.zonaUbicacionSede))}`}
                                                </Row>
                                                <Row><b>Sede Empleador Misión:</b> {sede.informacionSede.sedeEmpleadorMision}</Row>
                                                <Row><b>Empleador Misión:</b> {sede.documentoCompletoEmpleadorMision ? sede.documentoCompletoEmpleadorMision : 'N/A'}</Row>
                                            </div>
                                        </Col>
                                        <Col sm={4} md={4}>
                                            <div style={{fontSize: '14px'}}>
                                                <Row><b>Doc. Responsable:</b> {sede.documentoCompletoResponsable ? sede.documentoCompletoResponsable : 'N/A'}</Row>
                                                <Row><b>Nombre Responsable:</b> {sede.nombreCompletoResponsable ? sede.nombreCompletoResponsable : 'N/A'}</Row>
                                                <Row><b>Centros de Trabajo:</b> {sede.totalCT}</Row>
                                                <Row><b>Total Empleados:</b> {sede.totalEmpleados}</Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </Grid>
                            </td>
                        </tr>
                        )) 
                    }
                </tbody>
            </Table>
        );
    }
    
    obtenerListaSedes() {
        const totalSedes = this.props.estructuraEmpresa.sedes.length;
        const listaSedes: Array<DatosSede> = [];
        if(totalSedes > 0) {
            this.props.estructuraEmpresa.sedes.forEach(sede => {
                const totales = this.calcularTotales(sede);
                listaSedes.push({
                    informacionSede: sede,
                    documentoCompletoResponsable: this.construirDocumentoResponsableSede(sede),
                    nombreCompletoResponsable: this.construirNombreResponsableSede(sede),
                    documentoCompletoEmpleadorMision: this.construirDocumentoEmpleadorMision(sede),
                    totalCT: totales.totalCT,
                    totalEmpleados: totales.totalEmpleados
                });
            });
        }

        let numRegistros;
        if (listaSedes.length < this.state.registrosPorPagina) {
            numRegistros = listaSedes.length;
        } else {
            numRegistros = this.state.registrosPorPagina;
        }

        const listaPaginada = this.calcularSedesPorPagina(listaSedes, numRegistros, 1);

        this.setState({
            listaSedes: listaSedes,
            paginaActual: 1,
            listaPaginada: listaPaginada,
            registrosPorPagina: numRegistros
        });
    }


    calcularSedesPorPagina(listaTrabajadores: Array<DatosSede>, registrosPorPagina: number, paginaNum: number) {
        return listaTrabajadores.slice((paginaNum - 1) * registrosPorPagina, paginaNum * registrosPorPagina);
    }

    actualizarSedesPaginacion(pageIndex: number, registrosPorPagina: number) {
        const listaPaginadaCT = this.calcularSedesPorPagina(this.state.listaSedes, registrosPorPagina, pageIndex + 1);
        this.setState({
            listaPaginada: listaPaginadaCT,
            registrosPorPagina: registrosPorPagina, 
            paginaActual: pageIndex
        });
    }

    construirDocumentoResponsableSede(estructuraSede: EstructuraSede) {
        return(
            `${estructuraSede.tipoDocumentoResponsable}${estructuraSede.numeroDocumentoResponsable}`
        );
    }

    construirDocumentoEmpleadorMision(estructuraSede: EstructuraSede) {
        return(
            `${estructuraSede.tipoDocumentoEmpleadorMision}${estructuraSede.numeroDocumentoEmpleadorMision}`
        );
    }

    construirNombreResponsableSede = (estructuraSede: EstructuraSede) => {
        return(
            `${estructuraSede.primerNombreResponsable} ${estructuraSede.segundoNombreResponsable}
             ${estructuraSede.primerApellidoResponsable} ${estructuraSede.segundoApellidoResponsable} `
        );
    };

    calcularTotales(estructuraSede: EstructuraSede) {
        let totalEmpleados = 0;
        estructuraSede.centrosTrabajo.forEach(ct => {
            totalEmpleados += ct.empleados.length;
        });
        return {
            totalCT: estructuraSede.centrosTrabajo.length,
            totalEmpleados: totalEmpleados
        };
    }
}

interface TablaSedesEmpresaProps {
    estructuraEmpresa: EstructuraEmpresa,
    estructuraSuraEmpresa?: EstructuraSuraEmpresa
}

interface TablaSedesEmpresaState {
    listaSedes: Array<DatosSede>,
    totalSedes: number,
    listaPaginada: Array<DatosSede>,
    paginaActual: number,
    registrosPorPagina: number 
}

interface DatosSede {
    informacionSede: EstructuraSede,
    documentoCompletoResponsable: string,
    nombreCompletoResponsable: string,
    documentoCompletoEmpleadorMision: string,
    totalCT: number,
    totalEmpleados: number
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/componentes/TablaSedesEmpresa.tsx